<template>
  <div class="content home-page user-guide-page" :lang="isBurmese ? 'my' : 'en'">
    <div class="user-guide-inner">
      <header class="user-guide-header">
        <button class="user-guide-back" type="button" :aria-label="$t('Back')" @click="back">
          <img src="../../static/images/back.png" alt="">
        </button>
        <h1>{{ $t('UserGuide') }}</h1>
        <div class="user-guide-header-placeholder" aria-hidden="true"></div>
      </header>

      <div class="user-guide-card">
        <article :key="$i18n.locale" class="user-guide-content" :class="{ 'is-burmese': isBurmese }" tabindex="0" :aria-label="$t('UserGuide')">
          <section v-for="section in sections" :key="section.title">
            <h2>{{ section.title }}</h2>
            <p v-for="paragraph in section.paragraphs" :key="paragraph">{{ paragraph }}</p>
            <div v-for="topic in section.topics" :key="topic.title" class="user-guide-topic">
              <h3>{{ topic.title }}</h3>
              <p>{{ topic.text }}</p>
            </div>
          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import userGuide from '@/assets/content/userGuide'

export default {
  computed: {
    isBurmese() {
      return this.$i18n.locale === 'bur'
    },
    sections() {
      return this.isBurmese ? userGuide.bur : userGuide.en
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.user-guide-page {
  min-height: 0;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  background: #080126 url('../../static/images/livequiz/main_bg.jpg') no-repeat center center fixed;
  background-size: cover;
}

.user-guide-inner {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 86px 32px 48px;
  box-sizing: border-box;
}

.user-guide-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
}

.user-guide-back,
.user-guide-header-placeholder {
  width: 72px;
  height: 72px;
  flex-shrink: 0;
}

.user-guide-back {
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
  cursor: pointer;
}

.user-guide-back img {
  display: block;
  width: 100%;
}

.user-guide-header h1 {
  flex: 1;
  min-width: 0;
  margin: 0;
  text-align: center;
  font-size: 52px;
  line-height: 1.5;
  font-weight: 700;
  color: #fff;
  overflow-wrap: break-word;
  text-shadow: -2px -2px 0 rgba(231, 88, 124, .95), 2px -2px 0 rgba(231, 88, 124, .95), -2px 2px 0 rgba(231, 88, 124, .95), 2px 2px 0 rgba(231, 88, 124, .95);
}

.user-guide-card {
  flex: 1;
  min-height: 0;
  margin-top: 42px;
  padding: 34px 28px;
  border-radius: 30px;
  background: rgba(255, 255, 255, .94);
  box-shadow: 0 18px 40px rgba(73, 30, 20, .14);
}

.user-guide-content {
  height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding-right: 10px;
  font-size: 22px;
  line-height: 1.7;
  color: #222;
  overflow-wrap: break-word;
  white-space: pre-line;
}

.user-guide-content.is-burmese {
  line-height: 2;
}

.user-guide-content section + section {
  margin-top: 32px;
}

.user-guide-content h2,
.user-guide-content h3 {
  color: #111;
  font-weight: 700;
  line-height: inherit;
}

.user-guide-content h2 {
  margin: 0 0 20px;
  font-size: 30px;
}

.user-guide-content h3 {
  margin: 0 0 12px;
  font-size: 25px;
}

.user-guide-content p {
  margin: 0 0 20px;
}

.user-guide-content::-webkit-scrollbar {
  width: 8px;
}

.user-guide-content::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: #f6a121;
}

.user-guide-content::-webkit-scrollbar-track {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/page/userGuide.vue